import { render, staticRenderFns } from "./experience-data.vue?vue&type=template&id=30384238&scoped=true"
import script from "./experience-data.vue?vue&type=script&lang=js"
export * from "./experience-data.vue?vue&type=script&lang=js"
import style0 from "./experience-data.vue?vue&type=style&index=0&id=30384238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30384238",
  null
  
)

export default component.exports